import { render, staticRenderFns } from "./PrintButton.vue?vue&type=template&id=03c8ff74&scoped=true"
import script from "./PrintButton.vue?vue&type=script&lang=js"
export * from "./PrintButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c8ff74",
  null
  
)

export default component.exports